import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';

Vue.use(VueApollo);

let provider = null;

function createClient() {
	// HTTP connection to the API
	const httpLink = createHttpLink({
		// You should use an absolute URL here
		uri: `${process.env.VUE_APP_API_URL}?key=${process.env.VUE_APP_API_KEY}`,
	});

	// Cache implementation
	const cache = new InMemoryCache();

	// Create the apollo client
	const apolloClient = new ApolloClient({
		link: httpLink,
		cache,
	});

	return apolloClient;
}

/**
 * Create VueApollo Provider.
 */
export function getProvider() {
	if (!provider) {
		provider = new VueApollo({
			defaultClient: createClient(),
		});
	}
	return provider;
}
